const initialState = {
  //customer group get
    customerGroupFetching: false,
    customerGroupFetched: false,
    customerGroupData: {},
    customerGroupError: null,
  //add customer group
    addGroupFetching: false,
    addGroupFetched: false,
    addGroupData: {},
    addGroupError: null,
  //get benefits ladder
    benefitsLadderFetching: false,
    benefitsLadderFetched: false,
    benefitsLadderData: {},
    benefitsLadderError: null,
  //delete customer group
    deleteGroupFetching: false,
    deleteGroupFetched: false,
    deleteGroupData: {},
    deleteGroupError: null,
  // edit customer group
    editGroupFetching: false,
    editGroupFetched: false,
    editGroupData: {},
    editGroupError: null,
};
  
  export default function reducer(state = initialState, action) {
    switch (action.type) {
      
      case 'GET_CUSTOMER_GROUP_PENDING' : {
        state = Object.assign({}, state, {customerGroupFetching: true, customerGroupFetched: false});
        break;
      }
      case "GET_CUSTOMER_GROUP_FULFILLED": {
          state = Object.assign({}, state, { customerGroupFetching: false, customerGroupFetched: true, customerGroupData: action.data});
          break;
      }
      case 'GET_CUSTOMER_GROUP_REJECT': {
        state = Object.assign({}, state, { customerGroupFetching: false, customerGroupFetched: false, customerGroupData:{},customerGroupError: action.error });
        break;
      }

      case 'ADD_CUSTOMER_GROUP_PENDING' : {
        state = Object.assign({}, state, {addGroupFetching: true, addGroupFetched: false});
        break;
      }
      case "ADD_CUSTOMER_GROUP_FULFILLED": {
          state = Object.assign({}, state, { addGroupFetching: false, addGroupFetched: true, addGroupData: action.data});
          break;
      }
      case 'ADD_CUSTOMER_GROUP_REJECT': {
        state = Object.assign({}, state, { addGroupFetching: false, addGroupFetched: false, addGroupData:{},addGroupError: action.error });
        break;
      }

      case 'GET_BENEFITS_LADDER_PENDING' : {
        state = Object.assign({}, state, {benefitsLadderFetching: true, benefitsLadderFetched: false});
        break;
      }
      case "GET_BENEFITS_LADDER_FULFILLED": {
          state = Object.assign({}, state, { benefitsLadderFetching: false, benefitsLadderFetched: true, benefitsLadderData: action.data});
          break;
      }
      case 'GET_BENEFITS_LADDER_REJECT': {
        state = Object.assign({}, state, { benefitsLadderFetching: false, benefitsLadderFetched: false, benefitsLadderData:{},benefitsLadderError: action.error });
        break;
      }

      case 'DELETE_CUSTOMER_GROUP_PENDING' : {
        state = Object.assign({}, state, {deleteGroupFetching: true, deleteGroupFetched: false});
        break;
      }
      case "DELETE_CUSTOMER_GROUP_FULFILLED": {
          state = Object.assign({}, state, { deleteGroupFetching: false, deleteGroupFetched: true, deleteGroupData: action.data});
          break;
      }
      case 'DELETE_CUSTOMER_GROUP_REJECT': {
        state = Object.assign({}, state, { deleteGroupFetching: false, deleteGroupFetched: false, deleteGroupData:{},deleteGroupError: action.error });
        break;
      }

      case 'EDITE_CUSTOMER_GROUP_PENDING' : {
        state = Object.assign({}, state, {editGroupFetching: true, editGroupFetched: false});
        break;
      }
      case "EDITE_CUSTOMER_GROUP_FULFILLED": {
          state = Object.assign({}, state, { editGroupFetching: false, editGroupFetched: true, editGroupData: action.data});
          break;
      }
      case 'EDITE_CUSTOMER_GROUP_REJECT': {
        state = Object.assign({}, state, { editGroupFetching: false, editGroupFetched: false, editGroupData:{},editGroupError: action.error });
        break;
      }
      
      case 'BENEFITS_RESET': {
        return initialState
        break;
      }
    }
    return state;
  }
  
  
  


// WEBPACK FOOTER //
// ./src/store/reducers/benefitsLadderReducer.js